import { BusinessGroup } from 'components/search/utils';
import { Container } from 'ui';
import { FunctionComponent } from 'react';
import { SearchLauncherType } from 'components/www/availability-search/SearchLauncher';
import { Theme, css } from '@emotion/react';
import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import SearchLauncherWidget from 'consumer-page-widgets/SearchLauncherWidget';

const overall = ({ breakpoints, colors, spacing, typography }: Theme) => css`
  background-color: ${colors.bgDefault};
  margin-bottom: calc(${spacing(5)}px + ${typography.pxToRem(48)});
  ${breakpoints.down('sm')} {
    margin-bottom: 0;
  }
`;

const content = ({ colors, spacing }: Theme) => css`
  background-color: ${colors.bgLight};
  padding-bottom: ${spacing(5)}px;
  padding-top: ${spacing(6)}px;
  text-align: center;
`;

export interface SegmentedSearchHeroProps {
  businessGroup?: BusinessGroup;
  className?: string;
  defaultType?: SearchLauncherType;
  metroArea?: consumer.IMetroArea;
  title: string;
}

export const SegmentedSearchHero: FunctionComponent<SegmentedSearchHeroProps> = ({
  title,
  metroArea,
  businessGroup,
  defaultType,
}) => {
  return (
    <div css={overall}>
      <div css={content}>
        <Container>
          <Typography
            mb={6}
            component="h1"
            variant="decorative"
            data-testid="segmented-search-hero-title"
            align="center"
          >
            {title}
          </Typography>
        </Container>
      </div>
      <SearchLauncherWidget
        businessGroup={businessGroup}
        metroArea={metroArea}
        defaultType={defaultType}
      />
    </div>
  );
};
